import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "font-awesome/css/font-awesome.min.css";
import "./Assets/Styles/styles.css"

import ReactDOM from 'react-dom/client';

import App from './App';
// import './utils/i18n'

import reportWebVitals from './reportWebVitals';
import { ProfileDataContextProvider } from './Context/ProfileContext';
import { CodeContextProvider } from './Context/ApiCodeContext';
import ServicesContextProvider from './Context/ServicesContextProvider';
// import { ShowModalContextProvider } from './context/ShowModalContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ServicesContextProvider>
      <CodeContextProvider>
        <ProfileDataContextProvider>
          {/* <ShowModalContextProvider> */}
            {/* <Provider store={store}> */}
              <App />
              {/* </Provider> */}
          {/* </ShowModalContextProvider> */}
        </ProfileDataContextProvider>
      </CodeContextProvider>
    </ServicesContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
